import types from './types';

export const editExpenseFormSubmitRequest = (expenseId, formId) => ({
    type: types.EDIT_EXPENSE_FORM_SUBMIT_REQUEST,
    payload: {
        expenseId,
        formId,
    },
});
